<template>
  <div>
    <v-bottom-nav :value="true" app absolute :color="ui.colorNavigationBar">
        <v-btn :color="ui.btnColor" flat :to="this.getPreviousPage"
        :disabled="!enableBackBtn">
          <span>back</span>
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn :color="ui.btnColor" flat>
          <span>{{currentDate}}</span>
          <v-icon>today</v-icon>
        </v-btn>
        <v-btn :color="ui.btnColor" flat>
          <span>
            {{currentTime}}
          </span>
          <v-icon>schedule</v-icon>
        </v-btn>
        <v-btn :color="ui.btnColor" flat :to="documentSelected.page">
          <span>{{documentSelected.tag}}</span>
          <v-icon>{{documentSelected.icon}}</v-icon>
        </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
export default {
  data() {
    return {
      dialog: false
    };
  },
  mixins: [apptheme, dateFunctions, describeDocument],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getPreviousPage",
      "getCurrentPage",
      "getUser",
      "getDetail",
      "getDetailBasic"
    ]),
    homePage() {
      let page = "/signin";
      if (this.getUser !== null) {
        if (this.getUser.pref.page.home === "") {
          page = "/welcomehome";
        } else {
          page = this.getUser.pref.page.home;
        }
      }
      return page;
    },
    documentSelected() {
      let doc = {
        tag: "NA",
        icon: "home"
      };
      if (this.getDetail !== null && this.getDetail !== undefined) {
        doc.tag = this.getDetail.basic.tag;
        doc.icon = this.defineDocumentFromTag(doc.tag).icon;
        doc.page = this.defineDocumentFromTag(doc.tag).page;
      }
      return doc;
    },
    enableBackBtn() {
      let logic = false;
      if (
        this.getCurrentPage === "/treeview" &&
        this.getPreviousPage === "/registerlist"
      ) {
        logic = false;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic !== undefined &&
        this.getDetailBasic.tag === "A1" &&
        this.getPreviousPage === "/treeview"
      ) {
        logic = true;
      } else if (
        this.getPreviousPage === "/welcomehome" ||
        this.getPreviousPage === "/appdash" ||
        this.getPreviousPage === "/userdash" ||
        this.getPreviousPage === "/companydash" ||
        this.getPreviousPage === "/companydashsafety" ||
        this.getPreviousPage === "/companydashtechnical" ||
        this.getPreviousPage === "/companydashbusiness" ||
        this.getPreviousPage === "/companymanagement" ||
        this.getPreviousPage === "/companydashmaintainer" ||
        this.getPreviousPage === "/companydashviewengineer" ||
        this.getPreviousPage === "/companydashoperator" ||
        this.getPreviousPage === "/companydashviewoperator" ||
        this.getPreviousPage === "/facilitydash" ||
        this.getPreviousPage === "/facilitydashoperations" ||
        this.getPreviousPage === "/facilitydashmaintenance" ||
        this.getPreviousPage === "/facilitydashengineering" ||
        this.getPreviousPage === "/facilitydetail" ||
        this.getPreviousPage === "/facilitymanagement" ||
        this.getPreviousPage === "/registerlist"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  }
};
</script>
